import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import { Button, IconButton } from "@material-ui/core";
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { Row, Col, Input } from 'reactstrap';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    button: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    actionsContainer: {
        marginBottom: theme.spacing(2),
    },
    resetContainer: {
        padding: theme.spacing(3),
    },
}));

function getSteps() {
    return [
        'Support order information (this information is on the court order you are filing or have received)',
        'Person required to pay child or family support',
        'Person or agency to receive child or family support payments',
        'The child support order is for the following children',
        "Father's Information",
        "Mother's Information",
        "",
    ];
}


const ChildSupportCase = (props) => {
    const classes = useStyles();


    const [inputFields, setInputField] = useState([{ name: "", dob: "", number: ""}]);
    const [activeStep, setActiveStep] = React.useState(0);
    const steps = getSteps();




    const handleChangeInput = (index, event) => {
        const values = [...inputFields];
        values[index][event.target.id] = event.target.value;
        setInputField(values);

    }

    const handleAddFields = () => {
        setInputField([...inputFields, { name: "", dob: "", number: ""}])
    }


    const handleRemoveFields = (index) => {
        const values = [...inputFields];
        if (index = 1)
            values.splice(index, 1);
        setInputField(values);
    }

    const ColoredLine = ({ color }) => (
        <hr
            style={{
                borderTop: "2px solid",
                color: "black",
            }}
        />
    );

    function getStepContent(step) {
        switch (step) {
            case 0:
                return <div>
                    <Row style={{ marginTop: "10px", marginLeft: "15px" }}>
                        <Col lg="2.5">
                            <h6 style={{ marginTop: "10px" }} >a. Date order filed:</h6>
                        </Col>
                        <Col lg="3">
                            <Input type="Date" />
                        </Col>
                    </Row>

                    <Row style={{ marginTop: "10px", marginLeft: "1px" }}>
                        <Col lg="6">
                            <h6 style={{ marginTop: "6px" }}>b. </h6>
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "20px", marginTop: "-28px" }} />
                            <h6 style={{ marginTop: "-28px", marginLeft: "50px" }}>Initial child support or family support order</h6>
                        </Col>
                        <Col lg="5">
                            <Input type="checkbox" style={{ height: "20px", width: "20px" }} />
                            <h6 style={{ marginTop: "6px", marginLeft: "10px" }}>Modification</h6>
                        </Col>
                    </Row>

                    <Row style={{ marginTop: "10px", marginLeft: "1px" }}>
                        <Col>
                            <h6 style={{ marginTop: "6px" }}>c. </h6>
                            <h6 style={{ marginTop: "-26px", marginLeft: "20px" }}>Total monthly base current child or family
                         support amount ordered for children listed below, plus any monthly amount ordered payable on past-due support:</h6>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "10px", marginLeft: "1px" }}>
                        <h5>Child Support:</h5>
                    </Row>
                    <Row style={{ marginTop: "10px" }} >
                        <Col lg="12">
                            <h6 style={{ marginTop: "6px" }}>(1) </h6>
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "30px", marginTop: "-27px" }} />
                            <h6 style={{ marginTop: "-28px", marginLeft: "60px" }}>Current base child support:</h6>
                            <Input type="number" style={{ width: "300px", marginLeft: "300px", marginTop: "-33px" }} />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "10px" }}>
                        <Col lg="3">
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "30px" }} />
                            <h6 style={{ marginLeft: "60px", marginTop: "5px" }}>Reserved order</h6>
                        </Col>
                        <Col lg="6">
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "30px" }} />
                            <h6 style={{ marginLeft: "60px", marginTop: "5px" }}>$0 (zero) order</h6>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "10px" }} >
                        <Col lg="12">
                            <h6 style={{ marginTop: "6px" }}>(2) </h6>
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "30px", marginTop: "-27px" }} />
                            <h6 style={{ marginTop: "-28px", marginLeft: "60px" }}>Additional monthlysupport:</h6>
                            <Input type="number" style={{ width: "300px", marginLeft: "300px", marginTop: "-33px" }} />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "10px" }} >
                        <Col lg="12">
                            <h6 style={{ marginTop: "6px" }}>(3) </h6>
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "30px", marginTop: "-27px" }} />
                            <h6 style={{ marginTop: "-28px", marginLeft: "60px" }}>Total past-duesupport:</h6>
                            <Input type="number" style={{ width: "300px", marginLeft: "300px", marginTop: "-33px" }} />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "10px" }} >
                        <Col lg="12">
                            <h6 style={{ marginTop: "6px" }}>(4) </h6>
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "30px", marginTop: "-27px" }} />
                            <h6 style={{ marginTop: "-28px", marginLeft: "60px" }}>Payment on past- due support: </h6>
                            <Input type="number" style={{ width: "300px", marginLeft: "300px", marginTop: "-33px" }} />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "10px" }} >
                        <Col lg="4">
                            <h6 style={{ marginTop: "6px" }}>(5) </h6>
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "30px", marginTop: "-27px" }} />
                            <h6 style={{ marginTop: "-28px", marginLeft: "60px" }}>Wage withholding was</h6>
                        </Col>
                        <Col lg="2" style={{ marginTop: "7px" }}>
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginTop: "-1px" }} />
                            <h6 style={{ marginTop: "-1px", marginLeft: "10px" }}>ordered</h6>
                        </Col>
                        <Col lg="5">
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "-30px", marginTop: "7px" }} />
                            <h6 style={{ marginTop: "6px", marginLeft: "3px" }}>ordered but stayed until (date):</h6>
                            <Input type="date" style={{ width: "170px", marginLeft: "245px", marginTop: "-35px" }} />
                        </Col>
                    </Row>

                    <Row style={{ marginTop: "15px", marginLeft: "1px" }}>
                        <h5>Family Support:</h5>
                    </Row>
                    <Row style={{ marginTop: "10px" }} >
                        <Col lg="12">
                            <h6 style={{ marginTop: "6px" }}>(1) </h6>
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "30px", marginTop: "-27px" }} />
                            <h6 style={{ marginTop: "-28px", marginLeft: "60px" }}>Current base child support:</h6>
                            <Input type="number" style={{ width: "300px", marginLeft: "300px", marginTop: "-33px" }} />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "10px" }}>
                        <Col lg="3">
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "30px" }} />
                            <h6 style={{ marginLeft: "60px", marginTop: "5px" }}>Reserved order</h6>
                        </Col>
                        <Col lg="6">
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "30px" }} />
                            <h6 style={{ marginLeft: "60px", marginTop: "5px" }}>$0 (zero) order</h6>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "10px" }} >
                        <Col lg="12">
                            <h6 style={{ marginTop: "6px" }}>(2) </h6>
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "30px", marginTop: "-27px" }} />
                            <h6 style={{ marginTop: "-28px", marginLeft: "60px" }}>Additional monthlysupport:</h6>
                            <Input type="number" style={{ width: "300px", marginLeft: "300px", marginTop: "-33px" }} />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "10px" }} >
                        <Col lg="12">
                            <h6 style={{ marginTop: "6px" }}>(3) </h6>
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "30px", marginTop: "-27px" }} />
                            <h6 style={{ marginTop: "-28px", marginLeft: "60px" }}>Total past-duesupport:</h6>
                            <Input type="number" style={{ width: "300px", marginLeft: "300px", marginTop: "-33px" }} />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "10px" }} >
                        <Col lg="12">
                            <h6 style={{ marginTop: "6px" }}>(4) </h6>
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "30px", marginTop: "-27px" }} />
                            <h6 style={{ marginTop: "-28px", marginLeft: "60px" }}>Payment on past- due support: </h6>
                            <Input type="number" style={{ width: "300px", marginLeft: "300px", marginTop: "-33px" }} />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "10px" }} >
                        <Col lg="4">
                            <h6 style={{ marginTop: "6px" }}>(5) </h6>
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "30px", marginTop: "-27px" }} />
                            <h6 style={{ marginTop: "-28px", marginLeft: "60px" }}>Wage withholding was</h6>
                        </Col>
                        <Col lg="2" style={{ marginTop: "7px" }}>
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginTop: "-1px" }} />
                            <h6 style={{ marginTop: "-1px", marginLeft: "10px" }}>ordered</h6>
                        </Col>
                        <Col lg="5">
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "-30px", marginTop: "7px" }} />
                            <h6 style={{ marginTop: "6px", marginLeft: "3px" }}>ordered but stayed until (date):</h6>
                            <Input type="date" style={{ width: "170px", marginLeft: "245px", marginTop: "-35px" }} />
                        </Col>
                    </Row>

                    <Row style={{ marginTop: "15px", marginLeft: "1px" }}>
                        <h5>Spousal Support:</h5>
                    </Row>
                    <Row style={{ marginTop: "10px" }} >
                        <Col lg="12">
                            <h6 style={{ marginTop: "6px" }}>(1) </h6>
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "30px", marginTop: "-27px" }} />
                            <h6 style={{ marginTop: "-28px", marginLeft: "60px" }}>Current base child support:</h6>
                            <Input type="number" style={{ width: "300px", marginLeft: "300px", marginTop: "-33px" }} />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "10px" }}>
                        <Col lg="3">
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "30px" }} />
                            <h6 style={{ marginLeft: "60px", marginTop: "5px" }}>Reserved order</h6>
                        </Col>
                        <Col lg="6">
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "30px" }} />
                            <h6 style={{ marginLeft: "60px", marginTop: "5px" }}>$0 (zero) order</h6>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "10px" }} >
                        <Col lg="12">
                            <h6 style={{ marginTop: "6px" }}>(2) </h6>
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "30px", marginTop: "-27px" }} />
                            <h6 style={{ marginTop: "-28px", marginLeft: "60px" }}>Total past-duesupport:</h6>
                            <Input type="number" style={{ width: "300px", marginLeft: "300px", marginTop: "-33px" }} />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "10px" }} >
                        <Col lg="12">
                            <h6 style={{ marginTop: "6px" }}>(3) </h6>
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "30px", marginTop: "-27px" }} />
                            <h6 style={{ marginTop: "-28px", marginLeft: "60px" }}>Payment on past- due support: </h6>
                            <Input type="number" style={{ width: "300px", marginLeft: "300px", marginTop: "-33px" }} />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "10px" }} >
                        <Col lg="4">
                            <h6 style={{ marginTop: "6px" }}>(4) </h6>
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "30px", marginTop: "-27px" }} />
                            <h6 style={{ marginTop: "-28px", marginLeft: "60px" }}>Wage withholding was</h6>
                        </Col>
                        <Col lg="2" style={{ marginTop: "7px" }}>
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginTop: "-1px" }} />
                            <h6 style={{ marginTop: "-1px", marginLeft: "10px" }}>ordered</h6>
                        </Col>
                        <Col lg="5">
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "-30px", marginTop: "7px" }} />
                            <h6 style={{ marginTop: "6px", marginLeft: "3px" }}>ordered but stayed until (date):</h6>
                            <Input type="date" style={{ width: "170px", marginLeft: "245px", marginTop: "-35px" }} />
                        </Col>
                    </Row>
                </div>
            case 1:
                return <div>
                    <Input type="text" placeholder="Person required to pay child or family support (name):" />
                    <Input type="text" placeholder="Relationship to child (specify):" style={{ marginTop: "10px" }} />
                </div>;
            case 2:
                return <div>
                    <Input type="text" placeholder="Person or agency to receive child or family support payments (name):" />
                    <Input type="text" placeholder="Relationship to child (if applicable):" style={{ marginTop: "10px" }} />
                </div>;
            case 3:
                return <div>
                    <Row style={{ marginLeft: "15px" }}> 
                        {inputFields.map((inputField, index) => (
                            <div key={index}>
                                <Row>
                                    <Col lg="4" style={{ marginTop: "6px", textAlign: "center" }} ><h6>Child’s Full Name</h6></Col>
                                    <Col lg="4" style={{ marginTop: "6px", textAlign: "center" }} ><h6>Date of birth</h6></Col>
                                    <Col lg="4" style={{ marginTop: "6px", textAlign: "center" }} ><h6>Social security number</h6></Col>
                                </Row>
                                <Row>
                                    <Col lg="4" style={{ marginTop: "6px" }} >
                                        <Input type="text"
                                            onBlur={(e) => { props.handleDescriptionChange(inputFields); handleChangeInput(index, e) }} />
                                    </Col>
                                    <Col lg="4" style={{ marginTop: "6px" }} >
                                        <Input type="date" id="base-child-support-dob" />
                                    </Col>
                                    <Col lg="4" style={{ marginTop: "6px" }} >
                                        <Input type="number" id="base-child-support-mo" />
                                    </Col>
                                </Row>
                                <IconButton onClick={() => handleAddFields()} style={{ marginLeft: "730px", color: "black", marginTop: "15px" }}>
                                    <AddIcon />
                                </IconButton>
                                <IconButton onClick={() => handleRemoveFields(index)} style={{ color: "black", marginTop: "15px" }} >
                                    <RemoveIcon />
                                </IconButton>

                                <ColoredLine/>

                            </div>
                        ))}
                        
                    </Row>
                    
                    <Row>
                        <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "30px", marginTop: "10px" }} />
                        <h6 style={{ marginTop: "10px", marginLeft:"60px" }}>Additional children are listed on a page attached to this document.</h6>
                        <h6 style={{ marginTop: "10px", marginLeft:"30px" }}>You are required to complete the following information about yourself.  You are not required to provide information 
                            about the other person, but you are encouraged to provide as much as you can. This form is confidential and will not 
                            be filed in the court file. It will be maintained in a confidential file with the State of California.</h6>
                    </Row>
                </div>;
            case 4:
                return <div>
                    <Row>
                        <Col>
                        <h5>Father's Information</h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="6">
                            <h6 style={{marginTop:"15px"}}>Father’s name:</h6>
                            <Input type="text"/>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="6">
                            <h6 style={{marginTop:"15px"}}>Date of Birth:</h6>
                            <Input type="date" />
                        </Col>
                        <Col lg="6">
                        <h6 style={{marginTop:"15px"}}>Social security number:</h6>
                            <Input type="number"/>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="6" style={{marginTop:"15px"}}>
                            <h6>Street address:</h6>
                            <Input type="textarea" />
                        </Col>
                        <Col lg="6" style={{marginTop:"15px"}}>
                        <h6>Mailing address:</h6>
                            <Input type="textarea" />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="6" style={{marginTop:"15px"}}>
                            <h6>City, state, zip code:</h6>
                            <Input type="text" />
                        </Col>
                        <Col lg="6" style={{marginTop:"15px"}}>
                            <h6>City, state, zip code:</h6>
                            <Input type="text" />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="5" style={{marginTop:"15px"}}>
                            <h6>Driver’s license number:</h6>
                            <Input type="text" />
                        </Col>
                        <Col lg="3" style={{marginTop:"15px"}}>
                            <h6>State:</h6>
                            <Input type="text" />
                        </Col>
                        <Col lg="4" style={{marginTop:"15px"}}>
                            <h6>Telephone number:</h6>
                            <Input type="number" />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="4" style={{marginTop:"15px"}}>
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft:"3px"}} />
                            <h6 style={{marginLeft:"40px", marginTop:"5px"}}>Employed</h6>
                        </Col>
                        <Col lg="4" style={{marginTop:"15px"}}>
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft:"3px"}} />
                            <h6 style={{marginLeft:"40px", marginTop:"5px"}}>Not Employed</h6>
                        </Col>
                        <Col lg="4" style={{marginTop:"15px"}}>
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft:"3px"}}  />
                            <h6 style={{marginLeft:"40px", marginTop:"5px"}}>Self-Employed</h6>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="6" style={{marginTop:"15px"}}>
                            <h6>Employer’s name:</h6>
                            <Input type="textarea" />
                        </Col>
                        <Col lg="6" style={{marginTop:"15px"}}>
                            <h6>Street address:</h6>
                            <Input type="textarea" />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="6" style={{marginTop:"15px"}}>
                            <h6>City, state, zip code:</h6>
                            <Input type="text" />
                        </Col>
                        <Col lg="6" style={{marginTop:"15px"}}>
                            <h6>Telephone number:</h6>
                            <Input type="number" />
                        </Col>
                    </Row>
                </div> ;
            case 5:
                return <div>
                    <Row>
                        <Col>
                        <h5>Mother's Information</h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="6">
                            <h6 style={{marginTop:"15px"}}>Mother’s name:</h6>
                            <Input type="text"/>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="6">
                            <h6 style={{marginTop:"15px"}}>Date of Birth:</h6>
                            <Input type="date" />
                        </Col>
                        <Col lg="6">
                        <h6 style={{marginTop:"15px"}}>Social security number:</h6>
                            <Input type="number"/>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="6" style={{marginTop:"15px"}}>
                            <h6>Street address:</h6>
                            <Input type="textarea" />
                        </Col>
                        <Col lg="6" style={{marginTop:"15px"}}>
                        <h6>Mailing address:</h6>
                            <Input type="textarea" />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="6" style={{marginTop:"15px"}}>
                            <h6>City, state, zip code:</h6>
                            <Input type="text" />
                        </Col>
                        <Col lg="6" style={{marginTop:"15px"}}>
                            <h6>City, state, zip code:</h6>
                            <Input type="text" />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="5" style={{marginTop:"15px"}}>
                            <h6>Driver’s license number:</h6>
                            <Input type="text" />
                        </Col>
                        <Col lg="3" style={{marginTop:"15px"}}>
                            <h6>State:</h6>
                            <Input type="text" />
                        </Col>
                        <Col lg="4" style={{marginTop:"15px"}}>
                            <h6>Telephone number:</h6>
                            <Input type="number" />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="4" style={{marginTop:"15px"}}>
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft:"3px"}} />
                            <h6 style={{marginLeft:"40px", marginTop:"5px"}}>Employed</h6>
                        </Col>
                        <Col lg="4" style={{marginTop:"15px"}}>
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft:"3px"}} />
                            <h6 style={{marginLeft:"40px", marginTop:"5px"}}>Not Employed</h6>
                        </Col>
                        <Col lg="4" style={{marginTop:"15px"}}>
                            <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft:"3px"}}  />
                            <h6 style={{marginLeft:"40px", marginTop:"5px"}}>Self-Employed</h6>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="6" style={{marginTop:"15px"}}>
                            <h6>Employer’s name:</h6>
                            <Input type="textarea" />
                        </Col>
                        <Col lg="6" style={{marginTop:"15px"}}>
                            <h6>Street address:</h6>
                            <Input type="textarea" />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="6" style={{marginTop:"15px"}}>
                            <h6>City, state, zip code:</h6>
                            <Input type="text" />
                        </Col>
                        <Col lg="6" style={{marginTop:"15px"}}>
                            <h6>Telephone number:</h6>
                            <Input type="number" />
                        </Col>
                    </Row>
                </div>
            case 6:
                return <div>
                    <Row>
                        <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "10px"}} />
                        <h6 style={{marginLeft: "50px", marginTop: "6px" }}>A restraining order, protective order, or nondisclosure order due to domestic violence is in effect.</h6>
                    </Row>
                    <Row>
                        <h6 style={{marginLeft: "10px", marginTop: "6px" }}>a. The order protects:</h6>
                        <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "200px"}} />
                        <h6 style={{marginLeft: "70px", marginTop: "6px" }}>Father</h6>
                        <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "370px"}} />
                        <h6 style={{marginLeft: "120px", marginTop: "6px" }}>Mother</h6>
                        <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "540px"}} />
                        <h6 style={{marginLeft: "125px", marginTop: "6px" }}>Children</h6>
                    </Row>

                    <Row>
                        <h6 style={{marginLeft: "10px", marginTop: "6px" }}>b. From:</h6>
                        <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "200px"}} />
                        <h6 style={{marginLeft: "165px", marginTop: "6px" }}>Father</h6>
                        <Input type="checkbox" style={{ height: "20px", width: "20px", marginLeft: "370px"}} />
                        <h6 style={{marginLeft: "125px", marginTop: "6px" }}>Mother</h6>
                    </Row>

                    <Row>
                        <h6 style={{marginLeft: "10px", marginTop: "20px" }}>c. The restraining order expireson (date):</h6>
                        <Input type="date" style={{marginLeft: "325px", marginTop:"-35px", width:"300px"}} />
                    </Row>
                    <Row>
                        <h6 style={{marginLeft: "10px", marginTop: "6px" }}>I declare under penalty of perjury under the laws of the State of California that the foregoing is true and correct.</h6>
                    </Row>
                    <Row>
                        <h6 style={{marginLeft: "10px", marginTop: "20px" }}>Date:</h6>
                        <Input style={{marginLeft: "20px", marginTop: "12px", width:"300px" }} type="date" />
                    </Row>
                </div>
            default:
                return 'Unknown step';
        }
    }


    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    return (
        <div className={classes.root}>
            <Stepper activeStep={activeStep} orientation="vertical">
                {steps.map((label, index) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                        <StepContent>
                            <Typography>{getStepContent(index)}</Typography>
                            <div className={classes.actionsContainer}>
                                <div>
                                    <Button
                                        disabled={activeStep === 0}
                                        onClick={handleBack}
                                        className={classes.button}
                                    >
                                        Back
                  </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleNext}
                                        className={classes.button}
                                    >
                                        {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                                    </Button>
                                </div>
                            </div>
                        </StepContent>
                    </Step>
                ))}
            </Stepper>
            {activeStep === steps.length && (
                <Paper square elevation={0} className={classes.resetContainer}>
                    <Typography>All steps completed - you&apos;re finished</Typography>
                    <Button onClick={handleReset} className={classes.button}>
                        Reset
          </Button>
                </Paper>
            )}
        </div>
    );
}

export default (ChildSupportCase);